import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { GoogleLogout } from "react-google-login";
import { SignInContext } from "./context/SignInContext";
import { CardContext } from "./context/CardContext";
import styled from "styled-components";
import { GoogleButton } from "./GlobalStyles";
import { FcGoogle } from "react-icons/fc";

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const SignOutButton = (props) => {
	const { setQuestion } = props;
	const { setSignedIn } = useContext(SignInContext);
	const { setFlipped } = useContext(CardContext);

	const history = useHistory();

	const onLogoutSuccess = (response) => {
		setSignedIn(false);
		setFlipped(false);
		setQuestion("");
		localStorage.clear();
		history.push("/");
	};

	const onFailure = (response) => {
		console.log("logout failed");
	};

	return (
		<GoogleLogout
			clientId={clientId}
			render={(renderProps) => (
				<Button onClick={renderProps.onClick}>
					<FcGoogle />
					sign out
				</Button>
			)}
			onLogoutSuccess={onLogoutSuccess}
			onFailure={onFailure}
		/>
	);
};

export default SignOutButton;

const Button = styled(GoogleButton)``;
